import MaterialIconsReact from "material-icons-react";
import React, { useState } from "react";
import Button from "./Button";
import styles from "./Filter.module.css";

function Filter(props) {
  const [openFilter, setOpenFilter] = useState(false);

  const onClose = () => {
    setOpenFilter(false);
    props.onClose && props.onClose();
  }
  
  const toggleFilter = () => {
    if (openFilter) {
      onClose();
    } else {
      setOpenFilter(true);
    }
  }

  return (
    <div className={styles.filterLayout}>
      <div
        className={
          styles.filterWrapper + " " + (openFilter ? styles.selected : "")
        }
        style={props.customStyle}
        onClick={toggleFilter}
      >
        <MaterialIconsReact
          icon="filter_list"
          size={20}
          color={"#666666"}
        ></MaterialIconsReact>
        <span className={"ft-14 " + styles.filterText}>
          {props.title || "No filters applied"}
        </span>
        {openFilter ? (
          <MaterialIconsReact
            icon="expand_less"
            size={20}
            color={"#666666"}
          ></MaterialIconsReact>
        ) : (
          <></>
        )}
        {openFilter ? (
          <></>
        ) : (
          <MaterialIconsReact
            icon="expand_more"
            size={20}
            color={"#666666"}
          ></MaterialIconsReact>
        )}
      </div>
      {openFilter && (
        <div className={styles.menu}>
          <div className={styles.menuHeading}>
            <div className="ft-16 bold">Filter</div>
            <div className="cur-pointer" onClick={onClose}>
              <MaterialIconsReact icon="close" size={20}></MaterialIconsReact>
            </div>
          </div>
          <div className={styles.menuContent}>
            {props.children}
          </div>
          <div className={styles.buttonContainer}>
            <Button
              type="secondary"
              fillStyle="outline"
              onClick={props.clearFilter}
            >
              Clear Filter
            </Button>
            <Button
              type="primary"
              fillStyle="contained"
              className={styles.ml16}
              disabled={props.applyDisabled}
              onClick={() => {
                props.onFilter();
                onClose();
              }}
            >
              Apply Filter
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Filter;
